export default __webpack_public_path__ + "static/17-f4061bc224cb9b6e11176e9d7c236e92.jpg";